// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"660dfb0d","834":"b3268a5b"}[chunkId] + ".chunk.js";
};